import { render, staticRenderFns } from "./DataRateCom.vue?vue&type=template&id=125022c5&"
import script from "./DataRateCom.vue?vue&type=script&lang=ts&"
export * from "./DataRateCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports